/* @pareto-engineering/generator-front 1.0.12 */
import { urljoin as _u } from 'utils'

export const basePath = '/'

export const slugs = {
  TERMS      :'terms',
  PRIVACY    :'privacy',
  COOKIES    :'cookies',
  MSSTATEMENT:'msstatement',
}

export default {
  TERMS      :_u(basePath, 'terms'),
  PRIVACY    :_u(basePath, 'privacy'),
  COOKIES    :_u(basePath, 'cookies'),
  MSSTATEMENT:_u(basePath, 'msstatement'),
}
